import { parseJSON } from 'date-fns/parseJSON'

// Wrapper for zod transform usage
export function parseJSONDate(dateStr: string): Date {
    return parseJSON(dateStr)
}
